import type { PropsWithChildren } from 'react';

import { StatusCardLegacyListItemStyled } from './styles/StatusCardLegacyListItemStyled'
import { StatusCardLegacyListStyled } from './styles/StatusCardLegacyListStyled'

export interface IStatusCardLegacyListProps {}

export const StatusCardLegacyList = ({
  children,
}: PropsWithChildren<IStatusCardLegacyListProps>) => {
  return <StatusCardLegacyListStyled>{children}</StatusCardLegacyListStyled>
}

StatusCardLegacyList.Item = StatusCardLegacyListItemStyled

StatusCardLegacyList.displayName = 'StatusCardLegacyList'
